<template>
  <div class="info-box">
    <div class="flex-1 gap-x-5 grid grid-cols-2 overflow-hidden">
      <div class="flex flex-col overflow-hidden">
        <div
          class="flex-1 bg-gray-100 p-3 rounded-lg flex flex-col gap-y-3 overflow-hidden"
        >
          <el-input
            v-model="state.params.keywords"
            clearable
            placeholder="关键字"
            @keyup.enter="onLoad()"
            @clear="onLoad()"
          >
            <template #suffix>
              <el-icon
                @click="onLoad()"
                color="#a2a2a2"
                title="搜索"
                class="font-bold cursor-pointer hover:opacity-60"
                ><Search
              /></el-icon>
            </template>
          </el-input>
          <template v-if="state.list_data?.length > 0">
            <div
              class="flex-1 overflow-y-auto flex flex-col gap-y-3"
              :class="state.list_data?.length > 6 ? 'pr-3' : ''"
            >
              <div
                v-for="item in state.list_data"
                :key="item"
                class="flex items-center p-2.5 rounded-lg gap-x-3 hover:opacity-60 cursor-pointer bg-white"
                @click="onSelect(item)"
              >
                <c_Avatar
                  v-if="item.id"
                  :file_url="item.conferee?.avatar_attachment?.file_url"
                  :size="10"
                  :title="item.conferee?.name?.slice(0, 1)"
                />
                <div class="flex-1">
                  <ul class="flex items-center">
                    <li class="flex-1 gap-x-3 flex items-center">
                      <strong
                        style="color: var(--el-color-primary)"
                        class="cursor-pointer hover:underline"
                      >
                        {{ item.conferee?.name }}
                      </strong>
                      <c_sex
                        :value="item.conferee?.sex"
                        v-if="item.conferee?.id"
                      />
                      <text class="text-sm text-gray-400">{{
                        $phoneFormat(item.conferee?.phone)
                      }}</text>
                      <c_status
                        arrName="Meeting_Attend_Type"
                        v-if="item.id"
                        :value="item.attend_type"
                        showBg
                        :size="11"
                        :key="item.attend_type"
                      />
                    </li>
                  </ul>
                  <ul class="flex flex-wrap gap-x-2 gap-y-1 mt-1">
                    <el-tag
                      type="info"
                      size="small"
                      v-for="item in item.d_conferee_tag_json_arr"
                      :key="item"
                    >
                      {{ item }}
                    </el-tag>
                  </ul>
                </div>
                <el-icon
                  v-if="state.select_data?.some((w) => w.id == item.id)"
                  color="#080"
                  :size="16"
                >
                  <Select />
                </el-icon>
              </div>
            </div>
            <div class="flex justify-center">
              <el-pagination
                layout="prev, pager, next"
                :total="state.totalCount"
                :background="false"
                size="small"
                :default-page-size="20"
                style="
                  --el-pagination-bg-color: transparent;
                  --el-pagination-button-disabled-bg-color: transparent;
                "
              />
            </div>
          </template>
          <div class="text-center" v-else style="max-height: 70%">
            <el-image
              :src="require('@/assets/images/nodata.png')"
              style="width: 80%"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col overflow-hidden">
        <div>已选{{ state.select_data?.length }}人</div>
        <div class="flex-1 overflow-y-auto flex flex-col gap-y-1 pr-3">
          <div
            v-for="item in state.select_data"
            :key="item"
            class="flex items-center p-2.5 rounded-lg gap-x-5"
          >
            <c_Avatar
              v-if="item.conferee?.id"
              :file_url="item.conferee?.avatar_attachment?.file_url"
              :size="10"
              :title="item.conferee?.name?.slice(0, 1)"
            />
            <div class="flex-1 shrink-0">
              <ul class="flex items-center whitespace-nowrap gap-x-3">
                <li class="flex-1 gap-x-3 flex items-center">
                  <strong style="color: var(--el-color-primary)">
                    {{ item.conferee?.name }}
                  </strong>
                  <c_sex :value="item.sex" v-if="item.conferee?.id" />
                  <text>{{ $phoneFormat(item.conferee?.phone) }}</text>
                </li>
                <el-input-number
                  v-model="item.sort"
                  controls
                  size="small"
                  precision="0"
                  class="!w-20"
                >
                </el-input-number>
                <el-tooltip effect="dark" content="排序：数字越大，显示越靠前">
                  <el-icon class="cursor-pointer" style="margin-left: -5px">
                    <QuestionFilled />
                  </el-icon>
                </el-tooltip>
                <el-icon
                  @click="
                    state.select_data = state.select_data.filter(
                      (data) => data.id != item.id,
                    )
                  "
                  color="#f00"
                  :size="20"
                  class="hover:!text-red-300 cursor-pointer"
                >
                  <CircleClose />
                </el-icon>
              </ul>
              <ul class="flex flex-wrap gap-x-2 gap-y-1 mt-1">
                <el-tag
                  type="info"
                  size="small"
                  v-for="(tag, index) in item.d_conferee_tag_json_arr"
                  :key="tag"
                >
                  {{ tag }}
                </el-tag>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { dic_getConfereeType } from "@/http/data";
import {
  meeting_attendee_page,
  meeting_website_guest_addBatch,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      type: 1,
      params: {
        meeting_id: props.meeting_id,
        attend_type: 1, //仅加载嘉宾
      },
      lx_data: [],
      list_data: [],
      select_data: [],
    });
    onMounted(() => {
      onLoadLx();
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_attendee_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;

          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //加载类型
    const onLoadLx = () => {
      dic_getConfereeType().then((res) => {
        if (res.status == 200) state.lx_data = res.data?.data || [];
      });
    };

    const onSelect = (item) => {
      if (state.select_data.some((w) => w.id == item.id)) {
        state.select_data = state.select_data.filter((w) => w.id != item.id);
      } else {
        state.select_data.push({
          ...item,
          attend_type: state.type,
          sort: 0,
        });
      }
    };

    const onSubmit = () => {
      if (state.select_data?.length > 0) {
        ElMessageBox.confirm(
          `您本次共选择<strong style="color: #080">${state.select_data?.length}</strong>人，是否确定导入？`,
          "导入嘉宾",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            customClass: "c-delete-dialog",
            cancelButtonClass: "is-plain",
          },
        ).then(() => {
          meeting_website_guest_addBatch({
            meeting_id: props.meeting_id,
            batch_data: JSON.stringify(
              state.select_data.map((m) => {
                return {
                  meeting_attendee_id: m.id,
                  conferee_id: m.conferee_id,
                  sort: m.sort,
                };
              }),
            ),
          }).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        });
      } else {
        ElMessage.warning("请选择要操作的数据！");
      }
    };

    return { state, onLoad, onSelect, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
